let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("fliVL"), load("e7SBQ")]).then(() => parcelRequire('krw7z'));